import { SERVICE } from './constants'

export const GET_VENDOR_ID = `${SERVICE}/GET_VENDOR_ID`
export const GET_VENDOR_INFO = `${SERVICE}/GET_VENDOR_INFO`
export const RESET_VENDOR_INFO = `${SERVICE}/RESET_VENDOR_INFO`

export const FETCH_VENDOR_DETAILS = `${SERVICE}/FETCH_VENDOR_DETAILS`
export const FETCH_VENDOR_DETAILS_ERROR = `${SERVICE}/FETCH_VENDOR_DETAILS_ERROR`
export const FETCH_VENDOR_DETAILS_SUCCESS = `${SERVICE}/FETCH_VENDOR_DETAILS_SUCCESS`
